<!-- 左中 -->
<template>
    <div class="container">
        <div class='bg box_v'>
            <div class="title">办理量排名前十业务</div>
            <!--前三名-->
            <div class="box" style="padding:0 20px">
                <div class="top3 box_f1 box box_v"  v-if="topData.length>1">
                    <div class="bg_top2"></div>
                    <div class="title_top3">{{topData[1].handleCount}}件</div>
                    <div class="subtitle_top3">{{topData[1].title}}</div>
                </div>
                <div class="top3 box_f1 box box_v" v-if="topData.length">
                    <div class="bg_top1"></div>
                    <div class="title_top3">{{topData[0].handleCount}}件</div>
                    <div class="subtitle_top3">{{topData[0].title}}</div>
                </div>
                <div class="top3 box_f1 box box_v" v-if="topData.length>2">
                    <div class="bg_top3"></div>
                    <div class="title_top3">{{topData[2].handleCount}}件</div>
                    <div class="subtitle_top3">{{topData[2].title}}</div>
                </div>
            </div>
            <!--其他排名-->
            <div class="tr box">
                <div class="td1">排名</div>
                <div class="td2 box_f1">单位</div>
                <div class="td3">办理量</div>
                <div class="td4"></div>
            </div>
            <div class="tr_item box_f1 box" v-for="(item,index) in topData" :key="item.index" v-if="index>2 && index<10">
                <div class="td1">{{index+1}}</div>
                <div class="td2 box_f1">{{item.title}}</div>
                <div class="td3">{{item.handleCount}}件</div>
                <div class="td4"></div>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            topData:[]
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
       getData(){
           this.$get(this.urlobj.handleTop10).then(res=>{
               this.topData = res.rows
           })
       }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container{
    padding:0 0px 10px 0px;
    width:100%;
    height:100%;
}
.bg{
    width: 100%;
    background-image: url('../../../../assets/images/monitorpy/rightup.png');
    background-size: 100% 100%;
    margin-bottom:10px;
    margin-right:20px;
    height:100%;
}
.title{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin-left: 40px;
    margin-top: 20px
}

.top3{
    align-items: center;
    .bg_top1{
        margin-top:30px;
        width:90px;
        height:80px;
        background:url('../../../../assets/images/monitorpy/1.png');
        background-size: 100%;
    }
    .bg_top2{
        margin-top:90px;
        width:90px;
        height:80px;
        background:url('../../../../assets/images/monitorpy/2.png');
        background-size: 100%;
    
    }
    .bg_top3{
        margin-top:90px;
        width:90px;
        height:80px;
        background:url('../../../../assets/images/monitorpy/3.png');
        background-size: 100%;
    }
    .title_top3{
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 45px;
        background: linear-gradient(0deg, #00A8FF 10.205078125%, #4CECFF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .subtitle_top3{
        text-align: center;
        font-size: 16px;
        color: #BFE4FF;
    }
}


.tr{
    color:#0EFCFF;
    margin:10px;
    height: 28px;
    line-height:28px;
    background: linear-gradient(90deg, rgba(21, 144, 245, 0) 0%, #0067BC 48%, rgba(21, 144, 245, 0) 100%);
}
.td1{
    width:130px;
    text-align: center;
    color:#0EFCFF;
}
.td2{
    padding-left:40px;
    color:#0EFCFF;
}
.td3{
    width:100px;
    text-align: center;
}
.td4{
    width:60px;
}
.tr_item{
    //line-height: 45px;
    margin:0 10px;
    .td3{
        font-size: 14px;
        font-family: Digital dream Fat;
        font-style: italic;
        
        background: linear-gradient(180deg, #F5A418 0%, #EA7A24 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
}
</style>